package com.elan.edubridge.shared.domain.usecase

import com.elan.edubridge.shared.domain.model.DailyRosterEntry
import com.elan.edubridge.shared.domain.model.SessionState
import com.elan.edubridge.shared.domain.policy.MembershipPolicy
import com.elan.edubridge.shared.domain.repository.EduConnectRepository

/**
 * 반 로스터(v4 선생님 출결 화면 · 스태프 콘솔 출결 원장).
 *
 * 학생 개인의 출결은 개인정보이므로 이 경로는 **스태프에게만 열린다**(§4.6).
 * VIEWER가 호출하면 조회 자체를 하지 않고 빈 목록을 돌려준다 — rules가 거부하기 전에
 * 클라이언트가 먼저 막아 불필요한 `permission-denied`를 만들지 않는다.
 */
class GetClassRosterUseCase(
    private val repository: EduConnectRepository,
) {
    /**
     * @param classId null이면 학원 전체. 선생님은 배정 반으로 좁혀야 rules를 통과한다(§4.5).
     * @param serviceDate null이면 학원 timeZone 기준 오늘.
     */
    suspend operator fun invoke(
        session: SessionState,
        academyId: String,
        classId: String?,
        serviceDate: String?,
    ): List<DailyRosterEntry> {
        if (!MembershipPolicy.isStaff(session)) return emptyList()
        return repository.dailyRoster(academyId, serviceDate, classId)
    }
}
